import al from '../../../../../assets/bollards/blacktop/it-al-sm.png'; //
import ba from '../../../../../assets/bollards/blacktop/si-ba-me2.png'; //
import bg from '../../../../../assets/bollards/red/hr-bg-mk2.png'; // bg rare
import bg2 from '../../../../../assets/bollards/red/hu-bg2.png'; //
import bg3 from '../../../../../assets/bollards/red/bg3.png'; //
import cy from '../../../../../assets/bollards/red/cy.png'; //
import dk from '../../../../../assets/bollards/yellow/dk.png'; //
import dk2 from '../../../../../assets/bollards/nonwhitebody/dk2.png'; //
import ie from '../../../../../assets/bollards/nonwhitebody/ie.png'; //
import ee from '../../../../../assets/bollards/white/ee.png'; //
import ee2 from '../../../../../assets/bollards/yellow/ee2.png'; //
import at from '../../../../../assets/bollards/blacktop/at.png'; //
import cz from '../../../../../assets/bollards/orange/cz-sk.png'; //
import cz2 from '../../../../../assets/bollards/nonwhitebody/cz2-sk2.png'; //
import cz3 from '../../../../../assets/bollards/nonwhitebody/cz3-sk3.png'; //
import fi from '../../../../../assets/bollards/white/se2-fi.png'; //
import fi2 from '../../../../../assets/bollards/white/se3-fi2.png'; //
import fr from '../../../../../assets/bollards/red/fr.png'; //
import fr2 from '../../../../../assets/bollards/white/fr2.png'; //
import fr3 from '../../../../../assets/bollards/nonwhitebody/fr3.png'; //
import fr4 from '../../../../../assets/bollards/nonwhitebody/fr4.png'; //
import ge from '../../../../../assets/bollards/red/ge.png'; //
import de from '../../../../../assets/bollards/white/de-ch-se.png'; //
import gr from '../../../../../assets/bollards/red/gr.png'; //
import hu2 from '../../../../../assets/bollards/blue/hu2.png'; //
import is from '../../../../../assets/bollards/nonwhitebody/is.png'; //
import lv from '../../../../../assets/bollards/white/lv.png'; //
import lv2 from '../../../../../assets/bollards/yellow/lv2.png'; //
// import by from '../../../../../assets/bollards/by.png';
import lt from '../../../../../assets/bollards/orange/lt.png'; //
import li from '../../../../../assets/bollards/white/li.png'; //
import mk from '../../../../../assets/bollards/blacktop/mk.png'; //
import mk3 from '../../../../../assets/bollards/red/mk3.png'; //
// import mt from '../../../../../assets/bollards/mt.png';
import be from '../../../../../assets/bollards/yellow/be.png'; //
import fo from '../../../../../assets/bollards/nonwhitebody/fo.png'; //
import ad from '../../../../../assets/bollards/orange/ad-es2.png'; //
import lu from '../../../../../assets/bollards/white/lu.png'; //
// import mc from '../../../../../assets/bollards/mc.png';
import me from '../../../../../assets/bollards/blacktop/me.png'; //
import nl from '../../../../../assets/bollards/red/nl.png'; //
import nl2 from '../../../../../assets/bollards/red/nl2.png'; //
import no from '../../../../../assets/bollards/white/no.png'; //
import pl from '../../../../../assets/bollards/red/pl-ua3.png'; //
import pl2 from '../../../../../assets/bollards/red/pl2.png'; //
import pt from '../../../../../assets/bollards/white/pt.png'; //
import ro from '../../../../../assets/bollards/red/ro-md.png'; // ro rare
import es from '../../../../../assets/bollards/yellow/es.png'; //
import se4 from '../../../../../assets/bollards/yellow/se4.png'; //
import ch2 from '../../../../../assets/bollards/white/ch2.png'; //
import tr from '../../../../../assets/bollards/red/tr.png'; //
import gb from '../../../../../assets/bollards/blacktop/uk.png'; //
import ua from '../../../../../assets/bollards/red/ua.png'; //
import ua2 from '../../../../../assets/bollards/red/ua2-ru3.png'; //
import rs from '../../../../../assets/bollards/red/rs.png'; //
import rs2 from '../../../../../assets/bollards/red/rs2.png'; //
// import va from '../../../../../assets/bollards/va.png';
import ru from '../../../../../assets/bollards/blacktop/ru.png'; //
import ru2 from '../../../../../assets/bollards/red/ru2.png'; //

export const BOLLARDS = [
    al,    // 0
    ba,    // 1
    bg,    // 2
    bg2,   // 3
    cy,    // 4
    dk,    // 5
    dk2,   // 6
    ie,    // 7
    ee,    // 8
    ee2,   // 9
    at,    // 10
    cz,    // 11
    cz2,   // 12
    cz3,   // 13
    fi,    // 14
    fi2,   // 15
    fr,    // 16
    fr2,   // 17
    fr3,   // 18
    fr4,   // 19
    ge,    // 20
    de,    // 21
    gr,    // 22
    bg,    // 23
    bg2,    // 24
    hu2,   // 25
    is,    // 26
    al,    // 27
    lv,    // 28
    lv2,   // 29
    lt,    // 30
    cz,    // 31
    cz2,   // 32
    cz3,   // 33
    li,    // 34
    mk,    // 35
    bg,   // 36
    mk3,   // 37
    be,    // 38
    fo,    // 39
    ad,    // 40
    lu,    // 41
    me,    // 42
    ba,   // 43
    nl,    // 44
    nl2,   // 45
    no,    // 46
    pl,    // 47
    pl2,   // 48
    pt,    // 49
    ro,    // 50
    ro,    // 51
    ba,    // 52
    es,    // 53
    ad,   // 54
    de,    // 55
    fi,   // 56
    fi2,   // 57
    se4,   // 58
    de,    // 59
    ch2,   // 60
    tr,    // 61
    gb,    // 62
    ua,    // 63
    ua2,   // 64
    pl,   // 65
    al,    // 66
    rs,    // 67
    rs2,   // 68
    ru,    // 69
    ru2,   // 70
    ua2,    // 71
    bg3,   // 72
];

// Maps countries to their bollard indices in the BOLLARDS array
export const COUNTRY_INDEX_TO_BOLLARDS_INDEX = [
    [0],                // Albania (0)
    [1],        // Bosnia and Herzegovina (1)
    [2, 3, 72],         // Bulgaria (2)
    [4],                // Cyprus (3)
    [5, 6],             // Denmark (4)
    [7],                // Ireland (5)
    [8, 9],             // Estonia (6)
    [10],               // Austria (7)
    [11, 12, 13],       // Czech Republic (8)
    [14, 15],           // Finland (9)
    [16, 17, 18, 19],   // France (10)
    [20],               // Georgia (11)
    [21],               // Germany (12)
    [22],               // Greece (13)
    [23],           // Croatia (14)
    [24, 25],           // Hungary (15)
    [26],               // Iceland (16)
    [27],           // Italy (17)
    [28, 29],           // Latvia (18)
    [],                 // Belarus (19) - commented out in imports
    [30],               // Lithuania (20)
    [31, 32, 33],       // Slovakia (21)
    [34],               // Liechtenstein (22)
    [35, 36, 37],       // North Macedonia (23)
    [],                 // Malta (24) - commented out in imports
    [38],               // Belgium (25)
    [39],               // Faroe Islands (26)
    [40],           // Andorra (27)
    [41],               // Luxembourg (28)
    [],                 // Monaco (29) - commented out in imports
    [42, 43],           // Montenegro (30)
    [44, 45],           // Netherlands (31)
    [46],               // Norway (32)
    [47, 48],       // Poland (33)
    [49],               // Portugal (34)
    [50],               // Romania (35)
    [51],               // Moldova (36)
    [52],               // Slovenia (37)
    [53, 54],           // Spain (38)
    [55, 56, 57, 58],   // Sweden (39)
    [59, 60],           // Switzerland (40)
    [61],               // Turkey (41)
    [62],               // United Kingdom (42)
    [63, 64, 65],       // Ukraine (43)
    [66],               // San Marino (44)
    [67, 68],           // Serbia (45)
    [],                 // Holy See (Vatican City) (46) - commented out in imports
    [69, 70, 71]        // Russia (47)
];

export const COUNTRY_INDEX_TO_COMMON_BOLLARDS_INDEX = [
    [0],                // Albania (0)
    [1],        // Bosnia and Herzegovina (1)
    [],         // Bulgaria (2)
    [4],                // Cyprus (3)
    [5],             // Denmark (4)
    [7],                // Ireland (5)
    [8, 9],             // Estonia (6)
    [10],               // Austria (7)
    [11],       // Czech Republic (8)
    [14, 15],           // Finland (9)
    [16],   // France (10)
    [20],               // Georgia (11)
    [21],               // Germany (12)
    [22],               // Greece (13)
    [23],           // Croatia (14)
    [24],           // Hungary (15)
    [26],               // Iceland (16)
    [27],           // Italy (17)
    [28, 29],           // Latvia (18)
    [],                 // Belarus (19) - commented out in imports
    [30],               // Lithuania (20)
    [31],       // Slovakia (21)
    [34],               // Liechtenstein (22)
    [35, 36, 37],       // North Macedonia (23)
    [],                 // Malta (24) - commented out in imports
    [38],               // Belgium (25)
    [39],               // Faroe Islands (26)
    [40],           // Andorra (27)
    [41],               // Luxembourg (28)
    [],                 // Monaco (29) - commented out in imports
    [42, 43],           // Montenegro (30)
    [44],           // Netherlands (31)
    [46],               // Norway (32)
    [47, 48],       // Poland (33)
    [49],               // Portugal (34)
    [50],               // Romania (35)
    [51],               // Moldova (36)
    [52],               // Slovenia (37)
    [53],           // Spain (38)
    [55, 56, 57, 58],   // Sweden (39)
    [59, 60],           // Switzerland (40)
    [61],               // Turkey (41)
    [62],               // United Kingdom (42)
    [63, 64],       // Ukraine (43)
    [66],               // San Marino (44)
    [67, 68],           // Serbia (45)
    [],                 // Holy See (Vatican City) (46) - commented out in imports
    [69, 70, 71]        // Russia (47)
];

export const BOLLARD_INDEX_TO_COUNTRY_INDICES = [
    [0, 17, 44],  // al (0) - it-al-sm.png - Albania, Italy, San Marino
    [1, 37, 30],  // ba (1) - si-ba-me2.png - Bosnia, Slovenia, Montenegro
    [2, 14, 23],  // bg (2) - hr-bg-mk2.png - Bulgaria, Croatia, North Macedonia
    [2, 15],      // bg2 (3) - hu-bg2.png - Bulgaria, Hungary
    [3],          // cy (4) - cy.png - Cyprus
    [4],          // dk (5) - dk.png - Denmark
    [4],          // dk2 (6) - dk2.png - Denmark
    [5],          // ie (7) - ie.png - Ireland
    [6],          // ee (8) - ee.png - Estonia
    [6],          // ee2 (9) - ee2.png - Estonia
    [7],          // at (10) - at.png - Austria
    [8, 21],      // cz (11) - cz-sk.png - Czech Republic, Slovakia
    [8, 21],      // cz2 (12) - cz2-sk2.png - Czech Republic, Slovakia
    [8, 21],      // cz3 (13) - cz3-sk3.png - Czech Republic, Slovakia
    [9, 39],      // fi (14) - se2-fi.png - Finland, Sweden
    [9, 39],      // fi2 (15) - se3-fi2.png - Finland, Sweden
    [10],         // fr (16) - fr.png - France
    [10],         // fr2 (17) - fr2.png - France
    [10],         // fr3 (18) - fr3.png - France
    [10],         // fr4 (19) - fr4.png - France
    [11],         // ge (20) - ge.png - Georgia
    [12, 40, 39], // de (21) - de-ch-se.png - Germany, Switzerland, Sweden
    [13],         // gr (22) - gr.png - Greece
    [14, 2, 23],  // hr (23) - hr-bg-mk2.png - Croatia, Bulgaria, North Macedonia
    [15, 2],      // hu (24) - hu-bg2.png - Hungary, Bulgaria
    [15],         // hu2 (25) - hu2.png - Hungary
    [16],         // is (26) - is.png - Iceland
    [17, 0, 44],  // it (27) - it-al-sm.png - Italy, Albania, San Marino
    [18],         // lv (28) - lv.png - Latvia
    [18],         // lv2 (29) - lv2.png - Latvia
    [20],         // lt (30) - lt.png - Lithuania
    [21, 8],      // sk (31) - cz-sk.png - Slovakia, Czech Republic
    [21, 8],      // sk2 (32) - cz2-sk2.png - Slovakia, Czech Republic
    [21, 8],      // sk3 (33) - cz3-sk3.png - Slovakia, Czech Republic
    [22],         // li (34) - li.png - Liechtenstein
    [23],         // mk (35) - mk.png - North Macedonia
    [23, 14, 2],  // mk2 (36) - hr-bg-mk2.png - North Macedonia, Croatia, Bulgaria
    [23],         // mk3 (37) - mk3.png - North Macedonia
    [25],         // be (38) - be.png - Belgium
    [26],         // fo (39) - fo.png - Faroe Islands
    [27, 38],     // ad (40) - ad-es2.png - Andorra, Spain
    [28],         // lu (41) - lu.png - Luxembourg
    [30],         // me (42) - me.png - Montenegro
    [30, 1, 37],  // me2 (43) - si-ba-me2.png - Montenegro, Bosnia, Slovenia
    [31],         // nl (44) - nl.png - Netherlands
    [31],         // nl2 (45) - nl2.png - Netherlands
    [32],         // no (46) - no.png - Norway
    [33, 43],     // pl (47) - pl-ua3.png - Poland, Ukraine
    [33],         // pl2 (48) - pl2.png - Poland
    [34],         // pt (49) - pt.png - Portugal
    [35, 36],     // ro (50) - ro-md.png - Romania, Moldova
    [36, 35],     // md (51) - ro-md.png - Moldova, Romania
    [37, 1, 30],  // si (52) - si-ba-me2.png - Slovenia, Bosnia, Montenegro
    [38],         // es (53) - es.png - Spain
    [38, 27],     // es2 (54) - ad-es2.png - Spain, Andorra
    [39, 12, 40], // se (55) - de-ch-se.png - Sweden, Germany, Switzerland
    [39, 9],      // se2 (56) - se2-fi.png - Sweden, Finland
    [39, 9],      // se3 (57) - se3-fi2.png - Sweden, Finland
    [39],         // se4 (58) - se4.png - Sweden
    [40, 12, 39], // ch (59) - de-ch-se.png - Switzerland, Germany, Sweden
    [40],         // ch2 (60) - ch2.png - Switzerland
    [41],         // tr (61) - tr.png - Turkey
    [42],         // gb (62) - uk.png - United Kingdom
    [43],         // ua (63) - ua.png - Ukraine
    [43, 47],     // ua2 (64) - ua2-ru3.png - Ukraine, Russia
    [43, 33],     // ua3 (65) - pl-ua3.png - Ukraine, Poland
    [44, 17, 0],  // sm (66) - it-al-sm.png - San Marino, Italy, Albania
    [45],         // rs (67) - rs.png - Serbia
    [45],         // rs2 (68) - rs2.png - Serbia
    [47],         // ru (69) - ru.png - Russia
    [47],         // ru2 (70) - ru2.png - Russia
    [47, 43],      // ru3 (71) - ua2-ru3.png - Russia, Ukraine
    [2],          // bg3 (72) - Bulgaria
];

export const BOLLARD_INDEX_TO_COMMON_COUNTRY_INDICES = [
    [0, 17, 44],  // al (0) - it-al-sm.png - Albania, Italy, San Marino
    [1, 37, 30],  // ba (1) - si-ba-me2.png - Bosnia, Slovenia, Montenegro
    [2, 14, 23],  // bg (2) - hr-bg-mk2.png - Bulgaria, Croatia, North Macedonia
    [2, 15],      // bg2 (3) - hu-bg2.png - Bulgaria, Hungary
    [3],          // cy (4) - cy.png - Cyprus
    [4],          // dk (5) - dk.png - Denmark
    [4],          // dk2 (6) - dk2.png - Denmark
    [5],          // ie (7) - ie.png - Ireland
    [6],          // ee (8) - ee.png - Estonia
    [6],          // ee2 (9) - ee2.png - Estonia
    [7],          // at (10) - at.png - Austria
    [8, 21],      // cz (11) - cz-sk.png - Czech Republic, Slovakia
    [8, 21],      // cz2 (12) - cz2-sk2.png - Czech Republic, Slovakia
    [8, 21],      // cz3 (13) - cz3-sk3.png - Czech Republic, Slovakia
    [9, 39],      // fi (14) - se2-fi.png - Finland, Sweden
    [9, 39],      // fi2 (15) - se3-fi2.png - Finland, Sweden
    [10],         // fr (16) - fr.png - France
    [10],         // fr2 (17) - fr2.png - France
    [10],         // fr3 (18) - fr3.png - France
    [10],         // fr4 (19) - fr4.png - France
    [11],         // ge (20) - ge.png - Georgia
    [12, 40, 39], // de (21) - de-ch-se.png - Germany, Switzerland, Sweden
    [13],         // gr (22) - gr.png - Greece
    [14, 2, 23],  // hr (23) - hr-bg-mk2.png - Croatia, Bulgaria, North Macedonia
    [15, 2],      // hu (24) - hu-bg2.png - Hungary, Bulgaria
    [15],         // hu2 (25) - hu2.png - Hungary
    [16],         // is (26) - is.png - Iceland
    [17, 0, 44],  // it (27) - it-al-sm.png - Italy, Albania, San Marino
    [18],         // lv (28) - lv.png - Latvia
    [18],         // lv2 (29) - lv2.png - Latvia
    [20],         // lt (30) - lt.png - Lithuania
    [21, 8],      // sk (31) - cz-sk.png - Slovakia, Czech Republic
    [21, 8],      // sk2 (32) - cz2-sk2.png - Slovakia, Czech Republic
    [21, 8],      // sk3 (33) - cz3-sk3.png - Slovakia, Czech Republic
    [22],         // li (34) - li.png - Liechtenstein
    [23],         // mk (35) - mk.png - North Macedonia
    [23, 14, 2],  // mk2 (36) - hr-bg-mk2.png - North Macedonia, Croatia, Bulgaria
    [23],         // mk3 (37) - mk3.png - North Macedonia
    [25],         // be (38) - be.png - Belgium
    [26],         // fo (39) - fo.png - Faroe Islands
    [27],     // ad (40) - ad-es2.png - Andorra, Spain
    [28],         // lu (41) - lu.png - Luxembourg
    [30],         // me (42) - me.png - Montenegro
    [30, 1, 37],  // me2 (43) - si-ba-me2.png - Montenegro, Bosnia, Slovenia
    [31],         // nl (44) - nl.png - Netherlands
    [31],         // nl2 (45) - nl2.png - Netherlands
    [32],         // no (46) - no.png - Norway
    [33, 43],     // pl (47) - pl-ua3.png - Poland, Ukraine
    [33],         // pl2 (48) - pl2.png - Poland
    [34],         // pt (49) - pt.png - Portugal
    [35, 36],     // ro (50) - ro-md.png - Romania, Moldova
    [36, 35],     // md (51) - ro-md.png - Moldova, Romania
    [37, 1, 30],  // si (52) - si-ba-me2.png - Slovenia, Bosnia, Montenegro
    [38],         // es (53) - es.png - Spain
    [27],         // es2 (54) - ad-es2.png - Andorra
    [39, 12, 40], // se (55) - de-ch-se.png - Sweden, Germany, Switzerland
    [39, 9],      // se2 (56) - se2-fi.png - Sweden, Finland
    [39, 9],      // se3 (57) - se3-fi2.png - Sweden, Finland
    [39],         // se4 (58) - se4.png - Sweden
    [40, 12, 39], // ch (59) - de-ch-se.png - Switzerland, Germany, Sweden
    [40],         // ch2 (60) - ch2.png - Switzerland
    [41],         // tr (61) - tr.png - Turkey
    [42],         // gb (62) - uk.png - United Kingdom
    [43],         // ua (63) - ua.png - Ukraine
    [43, 47],     // ua2 (64) - ua2-ru3.png - Ukraine, Russia
    [33],     // ua3 (65) - pl-ua3.png - Poland
    [44, 17, 0],  // sm (66) - it-al-sm.png - San Marino, Italy, Albania
    [45],         // rs (67) - rs.png - Serbia
    [45],         // rs2 (68) - rs2.png - Serbia
    [47],         // ru (69) - ru.png - Russia
    [47],         // ru2 (70) - ru2.png - Russia
    [47, 43],      // ru3 (71) - ua2-ru3.png - Russia, Ukraine
    [2],          // bg3 (72) - Bulgaria
];